/*
 * Entity-name helpers for cardboard boxes.
 *
 * Each placed cardboard box owns a visual root entity and an anchor entity in
 * the PlayCanvas scene. The anchor marks the box's logical centre — the visual
 * root's origin is a corner of its panels — so drags read the resulting
 * position off the anchor when they are persisted. Names are derived from the
 * box id so multiple boxes can coexist and be looked up / picked individually.
 *
 * These live in a plain module (not the React component) so non-React code
 * such as the picker's drag behaviors can resolve box ids from entity names.
 */
export var ROOT_ENTITY_NAME = "Cardboard Box";
export var CARDBOARD_BOX_ANCHOR_ENTITY_NAME = "Cardboard Box Anchor";
export var boxRootEntityName = function (boxId) {
    return "".concat(ROOT_ENTITY_NAME, ":").concat(boxId);
};
export var boxAnchorEntityName = function (boxId) {
    return "".concat(CARDBOARD_BOX_ANCHOR_ENTITY_NAME, ":").concat(boxId);
};
/* Extract a box id from a (root or anchor) entity name, if it is a box. */
export var boxIdFromEntityName = function (name) {
    var rootPrefix = "".concat(ROOT_ENTITY_NAME, ":");
    var anchorPrefix = "".concat(CARDBOARD_BOX_ANCHOR_ENTITY_NAME, ":");
    if (name.startsWith(rootPrefix))
        return name.slice(rootPrefix.length);
    if (name.startsWith(anchorPrefix))
        return name.slice(anchorPrefix.length);
    return undefined;
};
